import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormMode } from '../utils/extensions/constantEx'
import { ServiceFormContextProvider } from '../utils/contexts/serviceFormContext';
import ServiceForm from './serviceForm';

export default function ServiceFormWrapper(props) {

    const { formMode } = props;

    const location = useLocation();

    const [serviceId, setServiceId] = useState(0);
    const [serviceNurseId, setServiceNurseId] = useState(0);
    const [selectedNurseId, setSelectedNurseId] = useState(0);
    const [formOpenMode, setFormOpenMode] = useState(formMode ?? FormMode.NewMode);
    const [navigateFromPage, setNavigateFromPage] = useState('');


    useEffect(() => {

        if (location && location.state && location.state.formMode === FormMode.NewMode &&
            location.state.selectedNurseId && location.state.selectedNurseId > 0) {
            setNavigateFromPage(location.state.from);
            setFormOpenMode(location.state.formMode);
            setSelectedNurseId(location.state.selectedNurseId);
            setFormOpenMode(FormMode.NewMode);
        } else if (location && location.state && location.state.formMode === FormMode.ViewMode &&
            location.state.serviceNurseId && location.state.serviceNurseId > 0) {
            setNavigateFromPage(location.state.from);
            setFormOpenMode(location.state.formMode);
            setServiceId(location.state.serviceId);
            setServiceNurseId(location.state.serviceNurseId);
        } else {
            setFormOpenMode(formMode ?? FormMode.NewMode);
        }
    }, [location]);


    return (
        <ServiceFormContextProvider>
            <ServiceForm formMode={formOpenMode} navigateFromPage={navigateFromPage} selectedNurseId={selectedNurseId}
                serviceId={serviceId} serviceNurseId={serviceNurseId} serviceNurseCount={location.state.serviceNurseCount ?? 0} />
        </ServiceFormContextProvider>
    );

}
